<template>
  <transition name="picker-fade">
    <div class="picker" v-show="state===1" @touchmove.prevent @click="cancel">
      <transition name="picker-move">
        <div class="picker-panel" v-if="state===1" @click.stop>
          <div class="picker-choose border-bottom-1px">
            <span v-if="hotelProduct&&hotelProduct!=''" class="productName">{{hotelProduct.ProduceName}}</span>
            <span v-else class="cancel" @click="cancel"></span>
            <span class="confirm" @click="confirm">{{$t('share.confirmTxt')}}</span>
          </div>
          <div class="picker-content">
            <slot> </slot>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<style scoped>
  .picker {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(37, 38, 45, .4);

  }

  .picker-fade-enter,
  .picker-fade-leave-active {
    opacity: 0
  }

  .picker-fade-enter-active,
  .picker-fade-leave-active {
    transition: all .5s ease-in-out;
  }


  .picker-panel {
    position: absolute;
    z-index: 600;
    bottom: 0;
    width: 100%;
    background: #fff;
  }
  .picker-move-enter,
  .picker-move-leave-active {
    transform: translate3d(0, 2.73rem, 0)
  }

  .picker-move-enter-active,
  .picker-move-leave-active {
    transition: all .3s ease-in-out
  }

  .picker-choose {
    position: relative;
    height: 0.45rem;
    color: #fff;
    background: #12a3ff
  }

  .picker-title {
    margin: 0;
    line-height: 0.45rem;
    font-weight: normal;
    text-align: center;
    font-size: 0.14rem;

  }

  .picker-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.1rem;
    border-bottom: 0.01rem solid #e3e3e3;
  }

  .confirm,
  .cancel {
    position: absolute;
    top: 0;
    padding: 0.1rem;
    font-size: 0.14rem
  }

  .confirm {
    right: 0;
  }

  .cancel {
    left: 0
  }

  .option-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .option-title div {
    flex: 3;
    text-align: center;
    font-size: 0.12rem;
  }

  .productName {
    position: absolute;
    top: 0;
    padding: 0.1rem;
    font-size: .16rem;
    width:80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
<script>
  import Scroll from './Scroll.vue'
  import BScroll from 'better-scroll'
  const STATE_HIDE = 0
  const STATE_SHOW = 1
  const COMPONENT_NAME = 'picker'
  const EVENT_VALUE_CHANGE = 'valuechange'
  const EVENT_CANCEL = 'cancel'
  const EVENT_CHANGE = 'change'
  export default {
    data() {
      return {
        state: STATE_HIDE,
      }
    },
    props: {
      cancelTxt: {
        type: String,
      },
      confirmTxt: {
        type: String,
      },
    },
    methods: {
      confirm() {
        this.hide();
      },
      cancel() {
        this.hide();
      },
      show(Product) {
        if(Product!=''){
          this.hotelProduct = Product
        }
        this.state = STATE_SHOW;
      },
      hide() {
        this.state = STATE_HIDE;
      },
    },
    components: {
      Scroll
    }
  }

</script>



// WEBPACK FOOTER //
// pop-out.vue?e0839c34